import { useEffect, useCallback, useRef } from 'react';
import { focusFirstField } from './focus-first-field';
export function getSiteHeaderHeight(formElement) {
    const classicHeader = document.querySelector('#SITE_HEADER');
    const potentialHeader = formElement.closest('main')?.previousElementSibling;
    const studioHeader = potentialHeader?.tagName === 'HEADER' ? potentialHeader : undefined;
    const header = classicHeader || studioHeader;
    const headerPosition = header && window.getComputedStyle(header).position;
    return header && (headerPosition === 'sticky' || headerPosition === 'fixed')
        ? header.getBoundingClientRect().height
        : 0;
}
export function getWixAdHeight() {
    const ad = document.querySelector('#WIX_ADS');
    return ad && window.getComputedStyle(ad).position === 'fixed'
        ? ad.getBoundingClientRect().height
        : 0;
}
export const useScrollToTopOfForm = (formId, stepId) => {
    const shouldScrollOnStepChange = useRef(false);
    const scrollToTopOfForm = useCallback(() => {
        const formElement = document
            .getElementById(`form-${formId}`)
            ?.closest('[data-hook="Form-wrapper"]');
        if (formElement) {
            const { top } = formElement.getBoundingClientRect();
            if (top < 0 || top > window.innerHeight) {
                const headerHeight = getSiteHeaderHeight(formElement);
                const wixAdHeight = getWixAdHeight();
                const newTop = top + window.scrollY - 20 - headerHeight - wixAdHeight;
                window.scrollTo({ top: newTop, behavior: 'smooth' });
            }
            focusFirstField(formId);
        }
    }, [formId]);
    useEffect(() => {
        if (shouldScrollOnStepChange.current) {
            scrollToTopOfForm();
            shouldScrollOnStepChange.current = false;
        }
        // We want to rely on stepId only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stepId]);
    return useCallback(() => {
        shouldScrollOnStepChange.current = true;
    }, []);
};
//# sourceMappingURL=use-scroll-to-top-of-form.js.map